import { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
    FormControl, Input, InputLabel, FormHelperText, Stack,
    Typography, Tooltip, IconButton, TextField, Box
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

// import { basicMsg } from '../../../../actions/swal_msg';

import {
    addTrackingGuide,
    // uploadOrderFile
} from '../../../../actions/orders';

const ShipOrder = ({ selectedOrder, setSelectedOrder }) => {
    const dispatch = useDispatch();
    const { id, order_num } = selectedOrder;

    // guia de seguimiento
    const [values, setValues] = useState({
        file: '', partner: '', tracking: ''
    });
    const { partner, tracking } = values;

    const [loading, setLoading] = useState(false);

    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = name === 'partner' ? target.value.toUpperCase() : target.value;
        if (value === '' || value.length <= 64)
            setValues(e => ({ ...e, [name]: value }));
    };

    const formValidator = () => {
        if (partner.length > 2 && partner.length <= 64) {
            if (tracking.length > 2 && tracking.length <= 64) {
                // if (file) {
                    if (id.length === 24)
                        return true;
                    else alert('No se pudo recuperar ID de pedido');
                // } else alert('No ha subido archivo');
            } else alert('Ingrese guía de seguimiento');
        } else alert('Ingrese paquetería');
        return false;
    };

    const saveTrackingGuide = async () => {
        if (formValidator()) {
            setLoading(true);
            dispatch(addTrackingGuide(
                { id, order_num, partner, tracking }, setSelectedOrder, setLoading)
            );

            // setLoadingButton(true);
            // const req = await uploadOrderFile(file, order_num);
            // if (req.status) {
            //     const fileId = req.resp.fileId;
            //     const req2 = await addTrackingGuide(
            //         { ...values, id, order_num, fileId }
            //     );
            //     if (req2.status) {
            //         setSelectedOrder({
            //             ...selectedOrder,
            //             delivery_status: 'Enviado',
            //             shipping: {
            //                 ...selectedOrder.shipping,
            //                 status: 'shipped',
            //                 tracking_guide: tracking
            //             }, fileId
            //         });
            //         setData(i => i.map(
            //             e => (e.id === id) ? ({
            //                 ...e,
            //                 delivery_status: 'Enviado',
            //                 shipping: {
            //                     ...e.shipping,
            //                     status: 'shipped',
            //                     tracking_guide: tracking
            //                 }, fileId
            //             }) : e
            //         ));
            //     }
        }
    };

    // cargar archivo
    // const loadFile = ({ target }) => {
    //     const files = target.files;
    //     if (files.length > 0) {
    //         if (['application/pdf', 'application/msword',
    //             'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(files[0].type))
    //             setValues((e) => ({ ...e, file: files[0] }));
    //         else basicMsg('Formato no soportado');
    //     }
    // };

    const pasteFromClipboard = async () => {
        if (!navigator.clipboard || !navigator.clipboard.readText)
            return false;
        try {
            const text = await navigator.clipboard.readText();
            setValues(e => ({ ...e, tracking: text }));  
        } catch (err) {};
    };

    return (
        <Stack spacing={2}
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start">
            <TextField
                name="partner"
                label="Paquetería"
                variant="standard"
                value={ partner }
                inputProps={{ maxLength: 64 }}
                onChange={ handleInputChange } />
                <Box>
                    <FormControl
                        variant="standard">
                        <InputLabel htmlFor="component-disabled">
                            Guía de seguimiento
                        </InputLabel>
                        <Input
                            name="tracking"
                            label="Guía de seguimiento"
                            variant="standard"
                            value={ tracking }
                            inputProps={{ maxLength: 64 }}
                            onChange={ handleInputChange } />
                        <FormHelperText>Tracking</FormHelperText>
                    </FormControl>
                    <IconButton onClick={ pasteFromClipboard }>
                        <ContentPasteIcon />
                    </IconButton>
                </Box>
            {/* {
                file &&
                    <Typography variant="overline" display="block" gutterBottom>
                        Archivo subido: { file.name }
                    </Typography>
            }
            <Box>
                <Button
                    variant="outlined"
                    component="label"
                    size="small">
                    Subir archivo
                    <input hidden accept="application/pdf, application/msword,
                        application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        name="archivo" type="file" onChange={ loadFile } />
                </Button>
            </Box> */}

            <Stack direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={2}>
                <LoadingButton
                    endIcon={<LocalShippingIcon />}
                    loading={ loading }
                    loadingPosition="end"
                    variant="contained"
                    onClick={ saveTrackingGuide }>
                    Enviado
                </LoadingButton>
                
                <Tooltip
                    title={
                        <Typography variant="caption">
                            Actualiza paquetería y envía correo electrónico
                        </Typography>
                    }
                >
                    <IconButton>
                        <HelpOutlineIcon />
                    </IconButton>
                </Tooltip>
            </Stack>
        </Stack>
    );
};

export default ShipOrder;